import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { element } from 'protractor';

@Injectable()
export class AccountStatusService {

  constructor(private http: HttpClient) { }
  private basePath = ENPOINT.url;
  private pdf: Array<any> = [];
  private pdfComplemento: Array<any> = [];
  private paths: Array<any> = [];
  httpOption;

  obtenerFacturas(proveedor, fechaInicio, fechaFin): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('proveedor', proveedor)
      .set('fechai', fechaInicio)
      .set('fechaf', fechaFin)
    };
    return this.http.get(this.basePath + 'estado-cta-prov/obtener-est-cuenta', options);
 //  return this.http.get('http://proveedoresqas.ddns.net:8081/SistemaContabilidad/estado-cta-prov/obtener-est-cuenta?_dc=1528114654296&proveedor=0000000369&sociedad=1001&fechai=2018-01-01T00%3A00%3A00&fechaf=2018-06-04T00%3A00%3A00&page=1&start=0&limit=25');
  }

  obtenerXML(obj, isRemision: boolean){
    let objpaths = {};
    if(isRemision) {
      objpaths = encodeURIComponent(obj.path_XML + obj.name_XML);
    }else {
      objpaths = encodeURIComponent(obj);
    }
    
    let apiURL = this.basePath + 'facturas/xml?ruta=' + objpaths;
    var win = window.open(apiURL, '_blank');
    if (win) {
      // Browser has allowed it to be opened
      win.focus();
    } else {
      // Broswer has blocked it
      alert('Por favor activa los popups en tu navegador');
    }
  }

  obtenerPDF(o, tipoConsulta) {
    if (tipoConsulta === '3') {
      let pdfComplemento = {ejercicio: o.ejercicio, folioSAP: o.id_DOC, sociedad: o.sociedad};
      let objComplemento = JSON.stringify(pdfComplemento);
      let apiURLComplemento = this.basePath + 'facturas/pdfComplemento?complementos=' + encodeURIComponent(objComplemento);
      var winComplemento = window.open(apiURLComplemento, '_blank');
      if (winComplemento) {
        // Browser has allowed it to be opened
        winComplemento.focus();
      } else {
        // Broswer has blocked it
        alert('Por favor activa los popups en tu navegador');
      }
    } else {
      let pdf = {cliente: o.cliente, serie: o.serie, folio: o.folio, fecha: o.fecha};
      let obj = JSON.stringify(pdf);
      let apiURL = this.basePath + 'facturas/pdf?pdf=' + encodeURIComponent(obj);
      var win = window.open(apiURL, '_blank');
      if (win) {
        // Browser has allowed it to be opened
        win.focus();
      } else {
        // Broswer has blocked it
        alert('Por favor activa los popups en tu navegador');
      }
    }
  }

  descargaMasivaArchivos(obj: Array<any>, flagXML: boolean, flagPDF: boolean, tipoConsulta){
    this.pdf = [];
    this.paths = [];
    obj.forEach(elemento => {
      if (flagPDF) {
        if (tipoConsulta === '3') {
          let objpdfComplementos = {ejercicio: elemento.ejercicio, folioSAP: elemento.id_DOC, sociedad: elemento.sociedad};
          this.pdfComplemento.push(objpdfComplementos);
        } else {
          let objpdf = {cliente: elemento.cliente, serie: elemento.serie, folio: elemento.folio, fecha: elemento.fecha};
          this.pdf.push(objpdf);
        }
      }
     
      if (flagXML) {
        let objpaths = {path: elemento.path_XML}
        this.paths.push(objpaths);
      }
      
    });

    // console.log(this.paths);
    // console.log(this.pdf);
    let jsonPaths = JSON.stringify(this.paths);
    let jsonPDF = JSON.stringify(this.pdf);
    let jsonPDFComplemento = JSON.stringify(this.pdfComplemento);

    this.httpOption = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data'
      }),
      responseType: 'arraybuffer',
      withCredentials: true
    }

    if (tipoConsulta === '3') {
      this.pdfComplemento = [];
      this.pdf = [];
      let formData = new FormData();
      formData.append('rutas', jsonPaths);
      formData.append('pdf', jsonPDF);
      formData.append('complementos', jsonPDFComplemento);

      return this.http.post(this.basePath + 'facturas/archivos', formData, this.httpOption);
    } else {
      this.pdfComplemento = [];
      this.pdf = [];
      let formData = new FormData();
      formData.append('rutas', jsonPaths);
      formData.append('pdf', jsonPDF);

      return this.http.post(this.basePath + 'facturas/archivos', formData, this.httpOption)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/account-status/account-status.service.ts